<template>
  <div class="p-2 sm:p-4 text-lexend overflow-x-hidden min-h-screen bg-gray-50 dark:bg-gray-900/50">
    <!-- Header Estilo Recepción -->
    <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-3 sm:gap-4 mb-3 sm:mb-5 mt-1 scroll-reveal">
      <div class="animate-fadeIn w-full sm:w-auto">
        <div class="flex items-center gap-2 mb-1">
          <div class="w-8 h-1 bg-blue-600 rounded-full"></div>
          <span class="text-[10px] sm:text-xs font-black text-blue-600 tracking-widest">Panel de Control</span>
        </div>
        <h1 class="text-xl sm:text-3xl font-black text-gray-900 dark:text-white tracking-tight flex items-center flex-wrap gap-2">
          Gestión de Servicios Inter
          <span class="px-2 sm:px-3 py-0.5 bg-blue-100 dark:bg-blue-900/40 text-blue-600 dark:text-blue-300 text-xs sm:text-sm font-black rounded-lg border border-blue-200 dark:border-blue-800">
            {{ servicios.length }}
          </span>
        </h1>
        <p class="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400 mt-0.5 flex items-center">
          <Icon icon="mdi:check-decagram-outline" class="mr-1 text-blue-500" />
          Agente Autorizado Fibra Óptica - Jean Informático
        </p>
      </div>
      <button @click="abrirModalRegistro" class="px-3 sm:px-6 py-2 sm:py-3 bg-blue-600 hover:bg-blue-700 text-white rounded-xl font-black text-[10px] sm:text-sm tracking-widest transition-all shadow-lg shadow-blue-200 dark:shadow-none flex items-center gap-2 w-full sm:w-auto justify-center">
        <Icon icon="mdi:plus-circle" class="text-base sm:text-xl" />
        <span class="hidden sm:inline">Nuevo Registro Inter</span>
        <span class="sm:hidden">Nuevo</span>
      </button>
    </div>

    <!-- Stats Estilo Recepción -->
    <div class="grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-2 sm:gap-3 mb-3 sm:mb-5">
      <div class="bg-white dark:bg-gray-800 p-2.5 sm:p-4 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700 flex items-center gap-2 sm:gap-4">
        <div class="p-2 sm:p-3 bg-gray-100 dark:bg-gray-700 rounded-xl text-gray-600 dark:text-gray-400">
          <Icon icon="mdi:format-list-bulleted" class="text-lg sm:text-2xl" />
        </div>
        <div>
          <p class="text-[8px] sm:text-[10px] text-gray-500 dark:text-gray-400 font-bold uppercase tracking-wider">Total</p>
          <h3 class="text-base sm:text-xl font-black text-gray-800 dark:text-white">{{ servicios.length }}</h3>
        </div>
      </div>
      <div class="bg-white dark:bg-gray-800 p-2.5 sm:p-4 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700 flex items-center gap-2 sm:gap-4 border-l-4 border-l-amber-400">
        <div class="p-2 sm:p-3 bg-amber-50 dark:bg-amber-900/20 rounded-xl text-amber-600 dark:text-amber-400">
          <Icon icon="mdi:clock-outline" class="text-lg sm:text-2xl" />
        </div>
        <div>
          <p class="text-[8px] sm:text-[10px] text-gray-500 dark:text-gray-400 font-bold uppercase tracking-wider">Pendientes</p>
          <h3 class="text-base sm:text-xl font-black text-amber-600">{{ totalPendientes }}</h3>
        </div>
      </div>
      <div class="bg-white dark:bg-gray-800 p-2.5 sm:p-4 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700 flex items-center gap-2 sm:gap-4 border-l-4 border-l-blue-400">
        <div class="p-2 sm:p-3 bg-blue-50 dark:bg-blue-900/20 rounded-xl text-blue-600 dark:text-blue-400">
          <Icon icon="mdi:progress-wrench" class="text-lg sm:text-2xl" />
        </div>
        <div>
          <p class="text-[8px] sm:text-[10px] text-gray-500 dark:text-gray-400 font-bold uppercase tracking-wider">En Proceso</p>
          <h3 class="text-base sm:text-xl font-black text-blue-600">{{ totalEnProceso }}</h3>
        </div>
      </div>
      <div class="bg-white dark:bg-gray-800 p-2.5 sm:p-4 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700 flex items-center gap-2 sm:gap-4 border-l-4 border-l-emerald-400">
        <div class="p-2 sm:p-3 bg-emerald-50 dark:bg-emerald-900/20 rounded-xl text-emerald-600 dark:text-emerald-400">
          <Icon icon="mdi:check-circle" class="text-lg sm:text-2xl" />
        </div>
        <div>
          <p class="text-[8px] sm:text-[10px] text-gray-500 dark:text-gray-400 font-bold uppercase tracking-wider">Instalados</p>
          <h3 class="text-base sm:text-xl font-black text-emerald-600">{{ totalInstalados }}</h3>
        </div>
      </div>
    </div>

    <!-- Search & Filters -->
    <div class="bg-white dark:bg-gray-800 p-3 sm:p-4 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700 mb-3 sm:mb-5 flex flex-wrap gap-3 sm:gap-4 items-center">
      <div class="relative flex-1 min-w-[200px] sm:min-w-[280px]">
        <Icon icon="mdi:magnify" class="absolute left-3 sm:left-4 top-1/2 -translate-y-1/2 text-gray-400 text-sm sm:text-base" />
        <input v-model="filtroBusqueda" type="text" placeholder="Buscar cliente, abonado o serial..." class="w-full pl-9 sm:pl-11 pr-3 sm:pr-4 py-2 sm:py-2.5 bg-gray-50 dark:bg-gray-700 border-2 border-gray-200 dark:border-gray-600 focus:border-blue-500 rounded-xl transition-all text-xs sm:text-sm text-gray-700 dark:text-white outline-none" />
      </div>
      <div class="flex items-center gap-1 sm:gap-2 min-w-[140px] sm:min-w-[200px] flex-1 sm:flex-none">
        <Icon icon="mdi:filter-variant" class="text-gray-400 text-sm sm:text-base" />
        <select v-model="filtroEstatus" class="flex-1 bg-gray-50 dark:bg-gray-700 border-2 border-gray-200 dark:border-gray-600 focus:border-blue-500 rounded-xl px-2 sm:px-4 py-2 sm:py-2.5 text-[10px] sm:text-sm text-gray-700 dark:text-white outline-none transition-all">
          <option value="TODOS">Todos los estados</option>
          <option value="PENDIENTE">Pendientes</option>
          <option value="EN PROCESO">En Proceso</option>
          <option value="INSTALADO">Instalados</option>
          <option value="CANCELADO">Cancelados</option>
        </select>
      </div>
    </div>

    <!-- Table Estilo Premium -->
    <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-md border border-gray-200 dark:border-gray-700 overflow-hidden animate-fadeInUp delay-100">
      <!-- Versión Desktop: Tabla -->
      <div class="hidden lg:block overflow-x-auto custom-scrollbar">
        <table class="w-full text-left border-collapse">
          <thead>
            <tr class="bg-gray-50 dark:bg-gray-900/50 border-b border-gray-200 dark:border-gray-700">
              <th class="px-5 sm:px-6 py-4 text-[11px] font-black text-gray-400 tracking-widest">Cliente / Abonado</th>
              <th class="px-5 sm:px-6 py-4 text-[11px] font-black text-gray-400 tracking-widest">Servicio / Plan</th>
              <th class="px-5 sm:px-6 py-4 text-[11px] font-black text-gray-400 tracking-widest">Estado</th>
              <th class="px-5 sm:px-6 py-4 text-[11px] font-black text-gray-400 tracking-widest text-center">Técnico</th>
              <th class="px-5 sm:px-6 py-4 text-[11px] font-black text-gray-400 tracking-widest">Equipos (Seriales)</th>
              <th class="px-5 sm:px-6 py-4 text-[11px] font-black text-gray-400 tracking-widest text-right">Acciones</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-100 dark:divide-gray-700">
            <tr v-if="cargando">
              <td colspan="6" class="px-5 sm:px-6 py-16 sm:py-20 text-center">
                <div class="flex flex-col items-center gap-3 sm:gap-4">
                  <Icon icon="mdi:loading" class="text-4xl sm:text-5xl text-blue-500 animate-spin" />
                  <p class="text-gray-400 font-medium text-sm animate-pulse">Cargando servicios Inter...</p>
                </div>
              </td>
            </tr>
            <tr v-else-if="serviciosFiltrados.length === 0">
              <td colspan="6" class="px-5 sm:px-6 py-16 sm:py-20 text-center">
                <div class="flex flex-col items-center gap-3 sm:gap-4 text-gray-400">
                  <div class="p-3 sm:p-4 bg-gray-50 dark:bg-gray-800 rounded-full">
                    <Icon icon="mdi:database-search-outline" class="text-4xl sm:text-5xl text-gray-300 dark:text-gray-600" />
                  </div>
                  <p class="text-base sm:text-lg font-medium">No se encontraron registros de Inter</p>
                  <button @click="filtroBusqueda = ''; filtroEstatus = 'TODOS'" class="text-blue-500 underline text-xs sm:text-sm">Limpiar filtros</button>
                </div>
              </td>
            </tr>
            <tr v-for="item in paginatedServicios" :key="item.idInterServicio" class="hover:bg-blue-50/30 dark:hover:bg-gray-700/30 transition-all group">
              <td class="px-5 sm:px-6 py-4">
                <div class="font-bold text-gray-800 dark:text-white group-hover:text-blue-600 transition-colors text-sm sm:text-base">{{ item.nombreCliente }}</div>
                <div class="text-[9px] sm:text-[10px] text-blue-600 dark:text-blue-400 bg-blue-50 dark:bg-blue-900/30 inline-block px-1.5 sm:px-2 py-0.5 rounded mt-1 font-mono font-bold">
                  ID: {{ item.numeroAbonado || 'SIN NÚMERO' }}
                </div>
              </td>
              <td class="px-5 sm:px-6 py-4">
                <div class="text-xs sm:text-sm font-bold text-gray-700 dark:text-gray-200">{{ item.tipoSolicitud }}</div>
                <div class="text-[10px] sm:text-xs text-gray-500 dark:text-gray-400">{{ item.planContratado }}</div>
              </td>
              <td class="px-5 sm:px-6 py-4">
                <span :class="[
                  'px-2.5 sm:px-3 py-1 rounded-full text-[9px] sm:text-[10px] font-black uppercase border shadow-sm inline-block',
                  item.estatus === 'PENDIENTE' ? 'bg-amber-50 text-amber-600 border-amber-100 dark:bg-amber-900/20 dark:text-amber-400 dark:border-amber-800' : '',
                  item.estatus === 'EN PROCESO' ? 'bg-blue-50 text-blue-600 border-blue-100 dark:bg-blue-900/20 dark:text-blue-400 dark:border-blue-800' : '',
                  item.estatus === 'INSTALADO' ? 'bg-emerald-50 text-emerald-600 border-emerald-100 dark:bg-emerald-900/20 dark:text-emerald-400 dark:border-emerald-800' : '',
                  item.estatus === 'CANCELADO' ? 'bg-rose-50 text-rose-600 border-rose-100 dark:bg-rose-900/20 dark:text-rose-400 dark:border-rose-800' : '',
                ]">
                  {{ item.estatus }}
                </span>
              </td>
              <td class="px-5 sm:px-6 py-4">
                <div class="flex flex-col items-center">
                  <div class="w-7 sm:w-8 h-7 sm:h-8 rounded-full bg-gray-100 dark:bg-gray-700 flex items-center justify-center mb-0.5 sm:mb-1">
                    <Icon icon="mdi:account-wrench" class="text-gray-500 dark:text-gray-400 text-sm sm:text-base" />
                  </div>
                  <span class="text-[8px] sm:text-[10px] font-bold text-gray-600 dark:text-gray-300 text-center">{{ item.nombreTecnico || 'No asignado' }}</span>
                </div>
              </td>
              <td class="px-5 sm:px-6 py-4">
                <div v-if="item.serialONT" class="flex items-center gap-1 sm:gap-1.5 text-[9px] sm:text-[10px] text-gray-700 dark:text-gray-300">
                  <Icon icon="mdi:router-wireless" class="text-blue-500 text-sm sm:text-base" />
                  <span class="font-bold opacity-50">ONT:</span> {{ item.serialONT }}
                </div>
                <div v-if="item.serialRouter" class="flex items-center gap-1 sm:gap-1.5 text-[9px] sm:text-[10px] text-gray-700 dark:text-gray-300 mt-0.5 sm:mt-1">
                  <Icon icon="mdi:wifi" class="text-indigo-500 text-sm sm:text-base" />
                  <span class="font-bold opacity-50">RTR:</span> {{ item.serialRouter }}
                </div>
                <div v-if="!item.serialONT && !item.serialRouter" class="text-[9px] sm:text-[10px] text-gray-400 italic">Pendiente por seriales</div>
              </td>
              <td class="px-5 sm:px-6 py-4">
                <div class="flex justify-end gap-0.5 sm:gap-1 flex-nowrap whitespace-nowrap">
                  <button @click="editarServicio(item)" class="p-1.5 sm:p-2 text-blue-600 hover:bg-blue-50 dark:hover:bg-blue-900/30 rounded-lg transition-all shadow-sm" title="Editar">
                    <Icon icon="mdi:pencil-outline" class="text-base sm:text-lg" />
                  </button>
                  <button v-if="item.estatus !== 'INSTALADO' && item.estatus !== 'CANCELADO'" @click="abrirModalPago(item)" class="p-1.5 sm:p-2 text-emerald-600 hover:bg-emerald-50 dark:hover:bg-emerald-900/30 rounded-lg transition-all shadow-sm" title="Finalizar/Cobrar">
                    <Icon icon="mdi:currency-usd" class="text-base sm:text-lg" />
                  </button>
                  <button @click="eliminarRegistro(item.idInterServicio)" class="p-1.5 sm:p-2 text-rose-600 hover:bg-rose-50 dark:hover:bg-rose-900/30 rounded-lg transition-all shadow-sm" title="Eliminar">
                    <Icon icon="mdi:trash-can-outline" class="text-base sm:text-lg" />
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Versión Mobile: Tarjetas -->
      <div class="lg:hidden space-y-3 p-2 sm:p-3">
        <div v-if="cargando" v-for="i in 3" :key="'load-mobile-'+i" class="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700 p-4 animate-pulse">
          <div class="h-4 bg-gray-100 dark:bg-gray-700 rounded w-full mb-2"></div>
          <div class="h-3 bg-gray-100 dark:bg-gray-700 rounded w-3/4"></div>
        </div>
        
        <div v-if="!cargando && serviciosFiltrados.length === 0" class="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700 p-8 text-center">
          <div class="flex flex-col items-center opacity-30 select-none">
            <Icon icon="mdi:database-search-outline" class="text-5xl mb-3" />
            <h4 class="text-lg font-black text-gray-400 tracking-widest">No hay registros</h4>
          </div>
        </div>
        
        <div v-for="item in paginatedServicios" :key="item.idInterServicio" class="bg-white dark:bg-gray-800 rounded-2xl shadow-md border border-gray-200 dark:border-gray-700 p-4 hover:shadow-lg transition-all duration-200">
          
          <div class="flex flex-wrap items-center justify-between gap-2 mb-3 pb-2 border-b border-gray-100 dark:border-gray-700">
            <div class="flex items-center gap-2">
              <span class="font-bold text-gray-800 dark:text-white text-sm">{{ item.nombreCliente }}</span>
              <span :class="[
                'px-2 py-0.5 rounded-lg text-[7px] sm:text-[8px] font-black uppercase border shadow-sm',
                item.estatus === 'PENDIENTE' ? 'bg-amber-50 text-amber-600 border-amber-100 dark:bg-amber-900/20 dark:text-amber-400 dark:border-amber-800' : '',
                item.estatus === 'EN PROCESO' ? 'bg-blue-50 text-blue-600 border-blue-100 dark:bg-blue-900/20 dark:text-blue-400 dark:border-blue-800' : '',
                item.estatus === 'INSTALADO' ? 'bg-emerald-50 text-emerald-600 border-emerald-100 dark:bg-emerald-900/20 dark:text-emerald-400 dark:border-emerald-800' : '',
                item.estatus === 'CANCELADO' ? 'bg-rose-50 text-rose-600 border-rose-100 dark:bg-rose-900/20 dark:text-rose-400 dark:border-rose-800' : '',
              ]">
                {{ item.estatus }}
              </span>
            </div>
            <div class="text-[9px] text-gray-400 font-mono font-bold">ID: {{ item.numeroAbonado || 'SIN NÚMERO' }}</div>
          </div>

          <div class="mb-2">
            <p class="font-bold text-gray-800 dark:text-white text-xs sm:text-sm">{{ item.tipoSolicitud }}</p>
            <p class="text-[10px] text-gray-500 dark:text-gray-400">{{ item.planContratado }}</p>
          </div>

          <div class="grid grid-cols-2 gap-1 mb-2 text-[10px]">
            <div class="flex items-center gap-1">
              <Icon icon="mdi:account-wrench" class="text-gray-400 text-sm" />
              <span class="font-bold text-gray-600 dark:text-gray-400">{{ item.nombreTecnico || 'No asignado' }}</span>
            </div>
            <div class="flex items-center gap-1 justify-end">
              <span class="font-black text-emerald-600 dark:text-emerald-400 text-xs">${{ (item.costoInstalacion || 0).toFixed(2) }}</span>
            </div>
          </div>

          <div class="flex flex-col gap-0.5 mb-2 text-[9px] sm:text-[10px] text-gray-500 dark:text-gray-400 bg-gray-50 dark:bg-gray-900/30 rounded-xl p-2">
            <div v-if="item.serialONT" class="flex items-center gap-1">
              <Icon icon="mdi:router-wireless" class="text-blue-500 text-sm" />
              <span class="font-bold opacity-50">ONT:</span> {{ item.serialONT }}
            </div>
            <div v-if="item.serialRouter" class="flex items-center gap-1">
              <Icon icon="mdi:wifi" class="text-indigo-500 text-sm" />
              <span class="font-bold opacity-50">RTR:</span> {{ item.serialRouter }}
            </div>
            <div v-if="!item.serialONT && !item.serialRouter" class="text-gray-400 italic">Pendiente por seriales</div>
          </div>

          <div class="flex flex-wrap items-center gap-1.5 pt-2 border-t border-gray-200 dark:border-gray-700">
            <button @click="editarServicio(item)" class="p-1.5 bg-blue-50 dark:bg-blue-900/30 text-blue-600 dark:text-blue-400 rounded-lg hover:bg-blue-600 hover:text-white transition-all shadow-sm" title="Editar">
              <Icon icon="mdi:pencil-outline" class="text-sm" />
            </button>
            <button v-if="item.estatus !== 'INSTALADO' && item.estatus !== 'CANCELADO'" @click="abrirModalPago(item)" class="p-1.5 bg-emerald-50 dark:bg-emerald-900/30 text-emerald-600 dark:text-emerald-400 rounded-lg hover:bg-emerald-600 hover:text-white transition-all shadow-sm" title="Finalizar">
              <Icon icon="mdi:currency-usd" class="text-sm" />
            </button>
            <button @click="eliminarRegistro(item.idInterServicio)" class="p-1.5 bg-rose-50 dark:bg-rose-900/30 text-rose-600 dark:text-rose-400 rounded-lg hover:bg-rose-600 hover:text-white transition-all shadow-sm" title="Eliminar">
              <Icon icon="mdi:trash-can-outline" class="text-sm" />
            </button>
          </div>
        </div>
      </div>

      <!-- Footer Paginación -->
      <div v-if="totalPaginas > 1" class="flex flex-col sm:flex-row justify-between items-center px-3 sm:px-8 py-3 sm:py-6 bg-gray-50/50 dark:bg-gray-800/30 gap-3 sm:gap-4">
        <p class="text-[9px] sm:text-xs font-bold text-gray-400 dark:text-gray-500 uppercase tracking-[0.2em]">
          Página <span class="text-blue-500">{{ paginaActual }}</span> de <span class="text-gray-600 dark:text-gray-300">{{ totalPaginas }}</span>
        </p>
        <div class="flex items-center gap-1 sm:gap-2">
          <button @click="paginaActual--" :disabled="paginaActual === 1" class="p-2 sm:p-3 bg-white dark:bg-gray-800 border-none rounded-xl sm:rounded-2xl shadow-sm text-gray-400 dark:text-gray-500 hover:text-blue-500 dark:hover:text-blue-400 disabled:opacity-30 disabled:cursor-not-allowed transition-all active:scale-95">
            <Icon icon="mdi:chevron-left" class="text-xl sm:text-2xl" />
          </button>
          <div class="flex gap-0.5 sm:gap-1">
            <template v-for="n in totalPaginas" :key="n">
              <button v-if="n === 1 || n === totalPaginas || (n >= paginaActual - 1 && n <= paginaActual + 1)" @click="paginaActual = n" :class="['w-8 sm:w-10 h-8 sm:h-10 rounded-xl sm:rounded-2xl text-[10px] sm:text-sm font-bold transition-all', paginaActual === n ? 'bg-blue-600 text-white shadow-lg shadow-blue-500/30' : 'bg-white dark:bg-gray-800 text-gray-400 hover:text-blue-500 dark:hover:text-blue-400']">
                {{ n }}
              </button>
              <span v-else-if="n === 2 || n === totalPaginas - 1" class="text-gray-300 px-0.5 sm:px-1 pt-1 sm:pt-2 font-black text-[10px] sm:text-sm">...</span>
            </template>
          </div>
          <button @click="paginaActual++" :disabled="paginaActual === totalPaginas" class="p-2 sm:p-3 bg-white dark:bg-gray-800 border-none rounded-xl sm:rounded-2xl shadow-sm text-gray-400 dark:text-gray-500 hover:text-blue-500 dark:hover:text-blue-400 disabled:opacity-30 disabled:cursor-not-allowed transition-all active:scale-95">
            <Icon icon="mdi:chevron-right" class="text-xl sm:text-2xl" />
          </button>
        </div>
      </div>
    </div>

    <!-- MODAL REGISTRO/EDICIÓN -->
    <Teleport to="body">
      <div v-if="modalAbierto" class="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-2 sm:p-4 z-[9998]" @click.self="cerrarModal">
        <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-4xl max-h-[95vh] overflow-hidden flex flex-col border border-gray-200 dark:border-gray-700 animate-zoomIn">
          <!-- Header Estilo Premium -->
          <div class="px-4 sm:px-6 py-3 sm:py-4 bg-gradient-to-r from-blue-600 to-indigo-700 text-white flex justify-between items-center flex-shrink-0">
            <div class="flex items-center gap-2 sm:gap-3">
              <div class="p-1.5 sm:p-2 bg-white/20 rounded-xl backdrop-blur-md">
                <Icon :icon="modoEdicion ? 'mdi:pencil-box' : 'mdi:plus-box'" class="text-xl sm:text-2xl" />
              </div>
              <div>
                <h2 class="text-sm sm:text-lg font-black leading-none">{{ modoEdicion ? 'ACTUALIZAR SERVICIO' : 'NUEVO REGISTRO INTER' }}</h2>
                <p class="text-[8px] sm:text-[10px] text-blue-100 font-bold tracking-widest uppercase mt-0.5">Jean Informático - Agente Autorizado</p>
              </div>
            </div>
            <button @click="cerrarModal" class="p-1.5 sm:p-2 hover:bg-white/10 rounded-full transition-colors">
              <Icon icon="mdi:close" class="text-xl sm:text-2xl" />
            </button>
          </div>

          <!-- Modal Body Estilo Recepción Express (2 Columnas) -->
          <div class="p-3 sm:p-6 overflow-y-auto custom-scrollbar bg-gray-50 dark:bg-gray-900/50 flex-1">
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-3 sm:gap-4">
              
              <!-- Columna Izquierda: Cliente -->
              <div class="space-y-3 sm:space-y-4">
                <!-- Tarjeta de Cliente (Estilo Idéntico) -->
                <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700 overflow-visible relative">
                  <div class="bg-gradient-to-r from-green-50 to-emerald-50 dark:from-gray-800 dark:to-gray-800 px-3 sm:px-4 py-2 border-b border-gray-100 dark:border-gray-700 rounded-t-2xl">
                    <h2 class="text-xs sm:text-sm font-bold text-gray-800 dark:text-white flex items-center">
                      <div class="p-1 bg-green-100 dark:bg-green-900/30 rounded-lg mr-2">
                        <Icon icon="mdi:account" class="text-green-600 dark:text-green-400 text-base sm:text-lg" />
                      </div>
                      Información del Cliente
                    </h2>
                  </div>
                  <div class="p-3 sm:p-4">
                    <!-- Pestañas Estilo Pill -->
                    <div class="flex space-x-1 bg-gray-100 dark:bg-gray-700 p-1 rounded-xl mb-3 sm:mb-4">
                      <button @click="modoCliente = 'buscar'" :class="['flex-1 px-2 sm:px-3 py-1 text-[9px] sm:text-xs font-bold rounded-lg transition-all', modoCliente === 'buscar' && !clienteSeleccionado ? 'bg-white dark:bg-gray-800 text-green-600 shadow-sm' : 'text-gray-400']">BUSCAR</button>
                      <button @click="modoCliente = 'crear'" :class="['flex-1 px-2 sm:px-3 py-1 text-[9px] sm:text-xs font-bold rounded-lg transition-all', modoCliente === 'crear' && !clienteSeleccionado ? 'bg-white dark:bg-gray-800 text-green-600 shadow-sm' : 'text-gray-400']">NUEVO</button>
                    </div>

                    <!-- Modo Buscar -->
                    <div v-if="modoCliente === 'buscar' && !clienteSeleccionado" class="relative">
                      <div class="relative">
                        <Icon icon="mdi:magnify" class="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-sm" />
                        <input v-model="buscarCliente" type="text" placeholder="Nombre, documento o teléfono..." class="w-full pl-9 sm:pl-10 pr-3 sm:pr-4 py-2 sm:py-2.5 border-2 border-gray-200 dark:border-gray-600 rounded-xl bg-white dark:bg-gray-700 focus:ring-2 focus:ring-green-500 text-xs sm:text-sm transition-all dark:text-white outline-none" @input="debounceBuscarClientes" @focus="mostrarClientesSiHay" />
                      </div>
                      
                      <!-- Dropdown -->
                      <div v-if="mostrarListaClientes && clientesEncontrados.length > 0" class="absolute mt-2 w-full bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 rounded-xl shadow-2xl max-h-60 overflow-y-auto z-50">
                        <div v-for="c in clientesEncontrados" :key="c.idCliente" @click="seleccionarCliente(c)" class="p-2 sm:p-3 hover:bg-gray-50 dark:hover:bg-gray-700 cursor-pointer border-b border-gray-100 dark:border-gray-700 last:border-b-0">
                          <p class="font-bold text-xs sm:text-sm text-gray-800 dark:text-white">{{ c.nombre }} {{ c.apellido }}</p>
                          <p class="text-[9px] sm:text-[10px] text-gray-500">{{ c.documento }} • {{ c.telefono }}</p>
                        </div>
                      </div>
                    </div>

                    <!-- Modo Crear -->
                    <div v-if="modoCliente === 'crear' && !clienteSeleccionado" class="space-y-2 sm:space-y-3 animate-fadeIn">
                      <div class="grid grid-cols-2 gap-2 sm:gap-3">
                        <div class="col-span-1">
                          <label class="block text-[8px] sm:text-[10px] font-black text-gray-400 uppercase mb-0.5 sm:mb-1">Doc.</label>
                          <input v-model="nuevoCliente.documento" type="text" class="w-full px-2 sm:px-3 py-1.5 sm:py-2 border-2 border-gray-200 dark:border-gray-600 rounded-xl text-[10px] sm:text-xs dark:bg-gray-700 dark:text-white" placeholder="V-000000" />
                        </div>
                        <div class="col-span-1">
                          <label class="block text-[8px] sm:text-[10px] font-black text-gray-400 uppercase mb-0.5 sm:mb-1">Nombre</label>
                          <input v-model="nuevoCliente.nombre" type="text" class="w-full px-2 sm:px-3 py-1.5 sm:py-2 border-2 border-gray-200 dark:border-gray-600 rounded-xl text-[10px] sm:text-xs dark:bg-gray-700 dark:text-white" />
                        </div>
                      </div>
                      <div class="grid grid-cols-2 gap-2 sm:gap-3">
                        <div class="col-span-1">
                          <label class="block text-[8px] sm:text-[10px] font-black text-gray-400 uppercase mb-0.5 sm:mb-1">Teléfono</label>
                          <input v-model="nuevoCliente.telefono" type="text" class="w-full px-2 sm:px-3 py-1.5 sm:py-2 border-2 border-gray-200 dark:border-gray-600 rounded-xl text-[10px] sm:text-xs dark:bg-gray-700 dark:text-white" />
                        </div>
                        <div class="col-span-1">
                          <label class="block text-[8px] sm:text-[10px] font-black text-gray-400 uppercase mb-0.5 sm:mb-1">Dirección</label>
                          <input v-model="nuevoCliente.direccion" type="text" class="w-full px-2 sm:px-3 py-1.5 sm:py-2 border-2 border-gray-200 dark:border-gray-600 rounded-xl text-[10px] sm:text-xs dark:bg-gray-700 dark:text-white" />
                        </div>
                      </div>
                      <button @click="guardarNuevoCliente" :disabled="guardandoCliente" class="w-full py-2 sm:py-2.5 bg-blue-600 text-white rounded-xl text-[10px] sm:text-xs font-black hover:bg-blue-700 transition-all flex items-center justify-center gap-1 sm:gap-2">
                        <Icon v-if="guardandoCliente" icon="mdi:loading" class="animate-spin text-sm sm:text-base" />
                        <Icon v-else icon="mdi:account-plus" class="text-sm sm:text-base" />
                        GUARDAR Y SELECCIONAR
                      </button>
                    </div>

                    <!-- Cliente Seleccionado -->
                    <div v-if="clienteSeleccionado" class="p-3 sm:p-4 bg-gradient-to-r from-green-50 to-emerald-50 dark:from-green-900/10 dark:to-emerald-900/10 rounded-2xl border border-green-200 dark:border-green-800/50 flex items-center justify-between">
                      <div class="flex items-center gap-2 sm:gap-3">
                        <div class="p-1.5 sm:p-2 bg-green-100 dark:bg-green-900/30 rounded-xl">
                          <Icon icon="mdi:account-check" class="text-green-600 dark:text-green-400 text-base sm:text-xl" />
                        </div>
                        <div>
                          <p class="font-bold text-gray-800 dark:text-white text-xs sm:text-sm">{{ clienteSeleccionado.nombre }} {{ clienteSeleccionado.apellido }}</p>
                          <p class="text-[9px] sm:text-[10px] text-gray-500 font-mono">{{ clienteSeleccionado.documento }} • {{ clienteSeleccionado.telefono }}</p>
                        </div>
                      </div>
                      <button @click="deseleccionarCliente" class="p-1 text-gray-400 hover:text-red-500 transition-colors">
                        <Icon icon="mdi:close-circle" class="text-lg sm:text-xl" />
                      </button>
                    </div>
                  </div>
                </div>

                <!-- Detalles del Servicio -->
                <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700 overflow-hidden">
                  <div class="bg-gradient-to-r from-blue-50 to-indigo-50 dark:from-gray-800 dark:to-gray-800 px-3 sm:px-4 py-2 border-b border-gray-100 dark:border-gray-700">
                    <h2 class="text-xs sm:text-sm font-bold text-gray-800 dark:text-white flex items-center">
                      <div class="p-1 bg-blue-100 dark:bg-blue-900/30 rounded-lg mr-2">
                        <Icon icon="mdi:file-document-edit" class="text-blue-600 dark:text-blue-400 text-base sm:text-lg" />
                      </div>
                      Detalles de la Solicitud
                    </h2>
                  </div>
                  <div class="p-3 sm:p-4 space-y-3 sm:space-y-4">
                    <div class="grid grid-cols-2 gap-2 sm:gap-4">
                      <div>
                        <label class="block text-[8px] sm:text-[10px] font-black text-gray-500 dark:text-gray-400 uppercase mb-0.5 sm:mb-1">Abonado Inter</label>
                        <input v-model="form.numeroAbonado" type="text" placeholder="0212-XXXX" class="w-full px-2 sm:px-3 py-1.5 sm:py-2 border-2 border-gray-200 dark:border-gray-600 rounded-xl text-[10px] sm:text-xs dark:bg-gray-700 dark:text-white" />
                      </div>
                      <div>
                        <label class="block text-[8px] sm:text-[10px] font-black text-gray-500 dark:text-gray-400 uppercase mb-0.5 sm:mb-1">Tipo Solicitud</label>
                        <select v-model="form.tipoSolicitud" class="w-full px-2 sm:px-3 py-1.5 sm:py-2 border-2 border-gray-200 dark:border-gray-600 rounded-xl text-[10px] sm:text-xs dark:bg-gray-700 dark:text-white">
                          <option value="INSTALACION">INSTALACIÓN NUEVA</option>
                          <option value="SOPORTE">SOPORTE TÉCNICO</option>
                          <option value="MUDANZA">MUDANZA</option>
                          <option value="OTRO">OTRO</option>
                        </select>
                      </div>
                    </div>
                    <div>
                      <label class="block text-[8px] sm:text-[10px] font-black text-gray-500 dark:text-gray-400 uppercase mb-0.5 sm:mb-1">Plan Contratado (Fibra)</label>
                      <input v-model="form.planContratado" type="text" placeholder="Ej: 200 Megas Simétrico" class="w-full px-2 sm:px-3 py-1.5 sm:py-2 border-2 border-gray-200 dark:border-gray-600 rounded-xl text-[10px] sm:text-xs dark:bg-gray-700 dark:text-white font-bold" />
                    </div>
                  </div>
                </div>
              </div>

              <!-- Columna Derecha: Equipos y Asignación -->
              <div class="space-y-3 sm:space-y-4">
                <!-- Estado del Equipo (Estilo Idéntico) -->
                <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700 overflow-hidden">
                  <div class="bg-gradient-to-r from-orange-50 to-amber-50 dark:from-gray-800 dark:to-gray-800 px-3 sm:px-4 py-2 border-b border-gray-100 dark:border-gray-700">
                    <h2 class="text-xs sm:text-sm font-bold text-gray-800 dark:text-white flex items-center">
                      <div class="p-1 bg-orange-100 dark:bg-orange-900/30 rounded-lg mr-2">
                        <Icon icon="mdi:router" class="text-orange-600 dark:text-orange-400 text-base sm:text-lg" />
                      </div>
                      Equipos y Seriales
                    </h2>
                  </div>
                  <div class="p-3 sm:p-4 space-y-3 sm:space-y-4">
                    <div class="grid grid-cols-1 sm:grid-cols-2 gap-2 sm:gap-4">
                      <div>
                        <label class="block text-[8px] sm:text-[10px] font-black text-gray-500 dark:text-gray-400 uppercase mb-0.5 sm:mb-1">Serial ONT (Modem)</label>
                        <input v-model="form.serialONT" type="text" placeholder="G-2425G-A..." class="w-full px-2 sm:px-3 py-1.5 sm:py-2 border-2 border-gray-200 dark:border-gray-600 rounded-xl text-[10px] sm:text-xs dark:bg-gray-700 dark:text-white font-mono" />
                      </div>
                      <div>
                        <label class="block text-[8px] sm:text-[10px] font-black text-gray-500 dark:text-gray-400 uppercase mb-0.5 sm:mb-1">Serial Router</label>
                        <input v-model="form.serialRouter" type="text" placeholder="ZTE-XXXX..." class="w-full px-2 sm:px-3 py-1.5 sm:py-2 border-2 border-gray-200 dark:border-gray-600 rounded-xl text-[10px] sm:text-xs dark:bg-gray-700 dark:text-white font-mono" />
                      </div>
                    </div>
                    <div>
                      <label class="block text-[8px] sm:text-[10px] font-black text-gray-500 dark:text-gray-400 uppercase mb-0.5 sm:mb-1">Estado de la Instalación</label>
                      <select v-model="form.estatus" class="w-full px-2 sm:px-3 py-1.5 sm:py-2 border-2 border-orange-200 dark:border-orange-900 rounded-xl text-[10px] sm:text-xs font-black dark:bg-gray-700 dark:text-orange-400 text-orange-600">
                        <option value="PENDIENTE">PENDIENTE</option>
                        <option value="EN PROCESO">EN PROCESO</option>
                        <option value="INSTALADO">INSTALADO</option>
                        <option value="CANCELADO">CANCELADO</option>
                      </select>
                    </div>
                  </div>
                </div>

                <!-- Asignación y Costos -->
                <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700 overflow-hidden">
                  <div class="bg-gradient-to-r from-purple-50 to-violet-50 dark:from-gray-800 dark:to-gray-800 px-3 sm:px-4 py-2 border-b border-gray-100 dark:border-gray-700">
                    <h2 class="text-xs sm:text-sm font-bold text-gray-800 dark:text-white flex items-center">
                      <div class="p-1 bg-purple-100 dark:bg-purple-900/30 rounded-lg mr-2">
                        <Icon icon="mdi:account-wrench" class="text-purple-600 dark:text-purple-400 text-base sm:text-lg" />
                      </div>
                      Asignación y Costos
                    </h2>
                  </div>
                  <div class="p-3 sm:p-4 space-y-3 sm:space-y-4">
                    <div>
                      <label class="block text-[8px] sm:text-[10px] font-black text-gray-500 dark:text-gray-400 uppercase mb-0.5 sm:mb-1">Técnico Asignado</label>
                      <div class="w-full px-2 sm:px-3 py-1.5 sm:py-2 border-2 border-gray-200 dark:border-gray-600 rounded-xl text-[10px] sm:text-xs dark:bg-gray-700 dark:text-white bg-gray-50 dark:bg-gray-800 cursor-not-allowed flex items-center">
                        <Icon icon="mdi:lock" class="mr-1 sm:mr-2 text-gray-400 text-sm sm:text-base" />
                        <span class="font-bold text-gray-600 dark:text-gray-300 text-[10px] sm:text-xs">{{ nombreTecnicoAsignado || 'Técnico Actual' }}</span>
                      </div>
                    </div>
                    <div class="grid grid-cols-2 gap-2 sm:gap-4">
                      <div>
                        <label class="block text-[8px] sm:text-[10px] font-black text-gray-500 dark:text-gray-400 uppercase mb-0.5 sm:mb-1">Costo ($)</label>
                        <input v-model.number="form.costoInstalacion" type="number" step="0.01" class="w-full px-2 sm:px-3 py-1.5 sm:py-2 border-2 border-gray-200 dark:border-gray-600 rounded-xl text-[10px] sm:text-xs dark:bg-gray-700 dark:text-white font-bold" />
                      </div>
                      <div>
                        <label class="block text-[8px] sm:text-[10px] font-black text-gray-500 dark:text-gray-400 uppercase mb-0.5 sm:mb-1 text-emerald-600">Pagado ($)</label>
                        <input v-model.number="form.montoPagado" type="number" step="0.01" class="w-full px-2 sm:px-3 py-1.5 sm:py-2 border-2 border-emerald-200 dark:border-emerald-900 rounded-xl text-[10px] sm:text-xs dark:bg-gray-700 dark:text-emerald-400 text-emerald-600 font-black" />
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Observaciones -->
                <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-100 dark:border-gray-700 p-3 sm:p-4">
                  <label class="block text-[8px] sm:text-[10px] font-black text-gray-500 dark:text-gray-400 uppercase mb-0.5 sm:mb-1">Observaciones Internas</label>
                  <textarea v-model="form.observaciones" rows="2" class="w-full px-2 sm:px-3 py-1.5 sm:py-2 border-2 border-gray-200 dark:border-gray-600 rounded-xl text-[10px] sm:text-xs dark:bg-gray-700 dark:text-white resize-none" placeholder="Detalles adicionales..."></textarea>
                </div>
              </div>
            </div>
          </div>

          <!-- Modal Footer Estilo Premium -->
          <div class="px-4 sm:px-6 py-3 sm:py-4 bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700 flex flex-col sm:flex-row justify-end gap-2 sm:gap-3 flex-shrink-0">
            <button @click="cerrarModal" class="w-full sm:w-auto px-4 sm:px-6 py-2 bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 rounded-xl font-bold hover:bg-gray-200 dark:hover:bg-gray-600 transition-all text-[10px] sm:text-xs">CANCELAR</button>
            <button @click="guardarServicio" class="w-full sm:w-auto px-6 sm:px-8 py-2 bg-blue-600 text-white rounded-xl font-black hover:bg-blue-700 transition-all shadow-lg shadow-blue-200 dark:shadow-none flex items-center justify-center gap-1 sm:gap-2 text-[10px] sm:text-xs uppercase tracking-widest">
              <Icon :icon="modoEdicion ? 'mdi:content-save' : 'mdi:check-circle'" />
              {{ modoEdicion ? 'Actualizar Registro' : 'Confirmar Registro' }}
            </button>
          </div>
        </div>
      </div>
    </Teleport>

    <!-- MODAL DE PAGO -->
    <Teleport to="body">
      <div v-if="showPaymentModal" class="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-3 sm:p-4 z-[9999]" @click.self="showPaymentModal = false">
        <div class="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl w-full max-w-md overflow-hidden animate-zoomIn">
          <div class="bg-gradient-to-r from-emerald-600 to-teal-700 px-4 sm:px-5 py-3 sm:py-4 flex items-center justify-between">
            <div class="flex items-center gap-1 sm:gap-2">
              <Icon icon="mdi:cash" class="text-white text-lg sm:text-xl" />
              <h3 class="text-sm sm:text-base font-black text-white">Finalizar Servicio Inter</h3>
            </div>
            <button @click="showPaymentModal = false" class="text-white/80 hover:text-white">
              <Icon icon="mdi:close" class="text-xl sm:text-2xl" />
            </button>
          </div>

          <div class="p-4 sm:p-5 space-y-3 sm:space-y-4">
            <!-- Información del servicio -->
            <div class="bg-gray-100 dark:bg-gray-700 p-2.5 sm:p-3 rounded-lg text-center">
              <p class="text-[9px] sm:text-xs text-gray-500">Plan</p>
              <p class="text-base sm:text-lg font-black text-emerald-600">{{ itemPago?.planContratado }}</p>
              <p class="text-[8px] sm:text-[10px] text-gray-400">Costo Instalación: ${{ totalAPagar.toFixed(2) }}</p>
            </div>

            <!-- Método de Pago -->
            <div>
              <label class="block text-[9px] sm:text-[10px] font-black text-gray-400 mb-1 uppercase">MÉTODO DE PAGO</label>
              <div class="grid grid-cols-4 gap-1 sm:gap-2">
                <button v-for="met in metodosPagoList" :key="met.val" @click="pagoForm.metodo = met.val" :class="['py-1.5 sm:py-2 rounded-lg text-[8px] sm:text-xs font-black transition-all', pagoForm.metodo === met.val ? 'bg-emerald-600 text-white' : 'bg-gray-100 dark:bg-gray-700']">
                  <Icon :icon="met.icon" class="text-base sm:text-lg mx-auto mb-0.5" />
                  <span class="text-[6px] sm:text-[8px]">{{ met.label }}</span>
                </button>
              </div>
            </div>

            <!-- Switch Crédito Empresa -->
            <div class="bg-amber-50 dark:bg-amber-900/20 p-2.5 sm:p-3 rounded-lg">
              <div class="flex items-center justify-between mb-1 sm:mb-2">
                <div class="flex items-center gap-1 sm:gap-2">
                  <Icon icon="mdi:cash-register" class="text-amber-600 text-sm sm:text-base" />
                  <span class="text-[9px] sm:text-[10px] font-black">Registrar Cobro en Caja</span>
                </div>
                <button @click="pagoForm.registrarEnCaja = !pagoForm.registrarEnCaja" :class="['relative w-8 sm:w-10 h-4 sm:h-5 rounded-full transition-colors', pagoForm.registrarEnCaja ? 'bg-emerald-600' : 'bg-gray-400']">
                  <span :class="['absolute top-0.5 w-3 sm:w-4 h-3 sm:h-4 rounded-full bg-white transition-transform', pagoForm.registrarEnCaja ? 'right-0.5' : 'left-0.5']"></span>
                </button>
              </div>
              <p class="text-[8px] sm:text-[9px] text-amber-600 dark:text-amber-400 font-bold">
                {{ pagoForm.registrarEnCaja ? '✓ Se registrará como INGRESO en la caja actual' : '✗ Solo se marcará como INSTALADO sin registrar en caja' }}
              </p>
            </div>

            <!-- SOLO si se registra en caja, mostrar opciones de pago -->
            <template v-if="pagoForm.registrarEnCaja">
              <div class="border-t border-gray-200 dark:border-gray-700 pt-3">
                <p class="text-[9px] sm:text-[10px] font-black text-gray-400 mb-2 text-center">INFORMACIÓN DEL PAGO</p>
                
                <!-- Tipo de Moneda -->
                <div class="mb-2 sm:mb-3">
                  <label class="block text-[9px] sm:text-[10px] font-black text-gray-400 mb-1 uppercase">TIPO DE MONEDA</label>
                  <div class="flex gap-2">
                    <button @click="pagoForm.moneda = 'USD'" :class="['flex-1 py-1.5 sm:py-2 rounded-lg text-[10px] sm:text-sm font-black', pagoForm.moneda === 'USD' ? 'bg-emerald-600 text-white' : 'bg-gray-100 dark:bg-gray-700']">USD $</button>
                    <button @click="pagoForm.moneda = 'VES'" :class="['flex-1 py-1.5 sm:py-2 rounded-lg text-[10px] sm:text-sm font-black', pagoForm.moneda === 'VES' ? 'bg-emerald-600 text-white' : 'bg-gray-100 dark:bg-gray-700']">VES Bs.</button>
                  </div>
                </div>

                <!-- Tasa de Cambio -->
                <div v-if="pagoForm.moneda === 'VES'" class="mb-2 sm:mb-3">
                  <label class="block text-[9px] sm:text-[10px] font-black text-gray-400 mb-1 uppercase">TASA DE CAMBIO (USD → VES)</label>
                  <input v-model="pagoForm.tasaCambio" type="number" step="0.01" placeholder="Ej: 40.00" class="w-full px-3 py-1.5 sm:py-2 border rounded-lg text-xs sm:text-sm bg-white dark:bg-gray-600 text-slate-800 dark:text-white" />
                </div>

                <!-- Referencia -->
                <div v-if="pagoForm.metodo !== 'EFECTIVO'" class="mb-2 sm:mb-3">
                  <label class="block text-[9px] sm:text-[10px] font-black text-gray-400 mb-1 uppercase">REFERENCIA / COMPROBANTE</label>
                  <input v-model="pagoForm.referencia" placeholder="Número de referencia" class="w-full px-3 py-1.5 sm:py-2 border rounded-lg text-xs sm:text-sm bg-white dark:bg-gray-600 text-slate-800 dark:text-white" />
                </div>

                <!-- Monto a Abonar -->
                <div>
                  <label class="block text-[9px] sm:text-[10px] font-black text-gray-400 mb-1 uppercase">MONTO A ABONAR</label>
                  <div class="relative">
                    <span class="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 text-[10px] sm:text-sm">{{ pagoForm.moneda === 'USD' ? '$' : 'Bs.' }}</span>
                    <input v-model="pagoForm.monto" type="number" step="0.01" placeholder="0.00" class="w-full pl-7 sm:pl-8 pr-3 py-1.5 sm:py-2 border rounded-lg text-xs sm:text-sm font-black bg-white dark:bg-gray-600 text-slate-800 dark:text-white" />
                  </div>
                </div>

                <!-- Mostrar equivalente en USD -->
                <div v-if="pagoForm.moneda === 'VES' && pagoForm.tasaCambio && pagoForm.monto > 0" class="mt-2 sm:mt-3 bg-blue-50 dark:bg-blue-900/20 p-1.5 sm:p-2 rounded-lg">
                  <div class="flex justify-between items-center text-[9px] sm:text-xs">
                    <span class="font-black text-blue-600">Equivalente en USD:</span>
                    <span class="font-black text-blue-700">$ {{ ((pagoForm.monto / pagoForm.tasaCambio) || 0).toFixed(2) }}</span>
                  </div>
                </div>
              </div>
            </template>

            <!-- Mensaje informativo -->
            <div class="bg-blue-50 dark:bg-blue-900/20 p-2.5 sm:p-3 rounded-lg">
              <div class="flex gap-1 sm:gap-2">
                <Icon icon="mdi:information" class="text-blue-500 text-base sm:text-lg shrink-0" />
                <p class="text-[8px] sm:text-[9px] text-blue-700 dark:text-blue-300 font-bold leading-tight">
                  <span v-if="!pagoForm.registrarEnCaja">
                    El servicio se marcará como INSTALADO sin registrar dinero en caja.
                  </span>
                  <span v-else>
                    El servicio se marcará como INSTALADO y el pago se registrará en caja.
                  </span>
                </p>
              </div>
            </div>
          </div>

          <div class="px-4 sm:px-5 py-3 bg-gray-50 dark:bg-gray-900/50 flex flex-col sm:flex-row gap-2">
            <button @click="showPaymentModal = false" class="w-full sm:flex-1 py-2 border border-gray-300 dark:border-gray-600 rounded-lg font-black text-[10px] sm:text-sm text-slate-700 dark:text-slate-300 hover:bg-gray-100 dark:hover:bg-gray-700 transition-all">Cancelar</button>
            <button @click="finalizarConPago" :disabled="paying || (pagoForm.registrarEnCaja && pagoForm.moneda === 'VES' && !pagoForm.tasaCambio && pagoForm.monto > 0)" class="w-full sm:flex-1 py-2 bg-emerald-600 text-white rounded-lg font-black text-[10px] sm:text-sm disabled:opacity-50 hover:bg-emerald-700 transition-all">
              {{ paying ? 'Procesando...' : 'Finalizar Servicio' }}
            </button>
          </div>
        </div>
      </div>
    </Teleport>
  </div>
</template>

<script>
import { Icon } from "@iconify/vue";
import { 
  obtenerInterServicios, 
  crearInterServicio, 
  actualizarInterServicio, 
  eliminarInterServicio,
  registrarPagoCaja
} from '@/api/interServicios';
import { obtenerClientes, crearCliente } from '@/api/clientes';
import { obtenerTecnicos } from '@/api/tecnicos';
import { getCurrentUser } from '@/api/index';
import Swal from 'sweetalert2';

export default {
  name: 'InterServicios',
  components: { Icon },
  data() {
    return {
      servicios: [],
      todosLosClientes: [],
      tecnicos: [],
      filtroBusqueda: '',
      filtroEstatus: 'TODOS',
      modalAbierto: false,
      modoEdicion: false,
      cargando: false,
      
      // Paginación
      paginaActual: 1,
      itemsPorPagina: 5,
      maxVisiblePages: 10,
      
      // Lógica de Clientes Estilo Recepción
      modoCliente: 'buscar', 
      buscarCliente: '',
      clienteSeleccionado: null,
      clientesEncontrados: [],
      cargandoClientes: false,
      mostrarListaClientes: false,
      timeoutBusqueda: null,
      guardandoCliente: false,
      nuevoCliente: { 
        tipoDocumento: 'cedula', 
        documento: '', 
        nombre: '', 
        apellido: '', 
        telefono: '', 
        email: '', 
        direccion: '', 
        estado: 'activo' 
      },

      form: {
        idInterServicio: null,
        idCliente: null,
        numeroAbonado: '',
        planContratado: '',
        tipoSolicitud: 'INSTALACION',
        estatus: 'PENDIENTE',
        serialONT: '',
        serialRouter: '',
        costoInstalacion: 0,
        montoPagado: 0,
        idTecnico: null,
        fechaInstalacion: null,
        observaciones: ''
      },

      showPaymentModal: false,
      itemPago: null,
      paying: false,
      pagoForm: {
        metodo: 'EFECTIVO',
        referencia: '',
        monto: 0,
        moneda: 'USD',
        tasaCambio: null,
        registrarEnCaja: true
      },
      metodosPagoList: [
        { val: 'EFECTIVO', label: 'Efectivo', icon: 'mdi:cash' },
        { val: 'TRANSFERENCIA', label: 'Transferencia', icon: 'mdi:bank-transfer' },
        { val: 'PAGO_MOVIL', label: 'Pago Móvil', icon: 'mdi:cellphone' },
        { val: 'ZELLE', label: 'Zelle', icon: 'mdi:send' }
      ]
    };
  },
  computed: {
    nombreTecnicoAsignado() {
      if (!this.form.idTecnico) return '';
      const t = this.tecnicos.find(x => x.idTecnico === this.form.idTecnico);
      return t ? `${t.nombre} ${t.apellido}` : '';
    },
    serviciosFiltrados() {
      return this.servicios.filter(s => {
        const matchSearch = (
          (s.nombreCliente || '').toLowerCase().includes(this.filtroBusqueda.toLowerCase()) ||
          (s.numeroAbonado && s.numeroAbonado.includes(this.filtroBusqueda)) ||
          (s.serialONT && s.serialONT.toLowerCase().includes(this.filtroBusqueda.toLowerCase()))
        );
        const matchEstatus = this.filtroEstatus === 'TODOS' || s.estatus === this.filtroEstatus;
        return matchSearch && matchEstatus;
      });
    },
    totalPendientes() { return this.servicios.filter(s => s.estatus === 'PENDIENTE').length; },
    totalEnProceso() { return this.servicios.filter(s => s.estatus === 'EN PROCESO').length; },
    totalInstalados() { return this.servicios.filter(s => s.estatus === 'INSTALADO').length; },
    totalAPagar() { return this.itemPago ? (this.itemPago.costoInstalacion || 0) : 0; },
    totalPaginas() { return Math.ceil(this.serviciosFiltrados.length / this.itemsPorPagina); },
    paginatedServicios() {
      const start = (this.paginaActual - 1) * this.itemsPorPagina;
      return this.serviciosFiltrados.slice(start, start + this.itemsPorPagina);
    },
    displayedPages() {
      const total = this.totalPaginas;
      const max = this.maxVisiblePages;
      const current = this.paginaActual;
      
      if (total <= max) {
        return Array.from({ length: total }, (_, i) => i + 1);
      }
      
      let start = Math.max(1, current - Math.floor(max / 2));
      let end = start + max - 1;
      
      if (end > total) {
        end = total;
        start = Math.max(1, end - max + 1);
      }
      
      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    }
  },
  methods: {
    goToFirstPage() { this.paginaActual = 1; },
    goToLastPage() { this.paginaActual = this.totalPaginas; },
    
    async cargarDatos() {
      this.cargando = true;
      try {
        const [resS, resC, resT] = await Promise.all([
          obtenerInterServicios(),
          obtenerClientes(),
          obtenerTecnicos()
        ]);
        
        if (resS && resS.success) this.servicios = resS.data;
        if (resC && resC.success) this.todosLosClientes = resC.data;
        if (resT && resT.success) this.tecnicos = resT.data;
      } catch (error) {
        console.error('Error cargando datos del módulo Inter:', error);
      } finally {
        this.cargando = false;
      }
    },

    debounceBuscarClientes() { 
      this.mostrarListaClientes = true; 
      if (this.timeoutBusqueda) clearTimeout(this.timeoutBusqueda); 
      this.timeoutBusqueda = setTimeout(() => this.buscarClientesLocal(), 300); 
    },
    mostrarClientesSiHay() {
      if (!this.buscarCliente) this.clientesEncontrados = this.todosLosClientes.slice(0, 5);
      if (this.clientesEncontrados.length > 0) this.mostrarListaClientes = true;
    },
    buscarClientesLocal() { 
      if (!this.buscarCliente) {
        this.clientesEncontrados = this.todosLosClientes.slice(0, 5);
        return;
      }
      const termino = this.buscarCliente.toLowerCase().trim();
      this.clientesEncontrados = this.todosLosClientes.filter(c => 
        `${c.nombre} ${c.apellido}`.toLowerCase().includes(termino) ||
        (c.documento || '').toLowerCase().includes(termino)
      ).slice(0, 10);
    },
    seleccionarCliente(c) {
      this.clienteSeleccionado = c;
      this.form.idCliente = c.idCliente || c.id;
      this.mostrarListaClientes = false;
      this.buscarCliente = '';
    },
    deseleccionarCliente() {
      this.clienteSeleccionado = null;
      this.form.idCliente = null;
    },
    async guardarNuevoCliente() {
      if (!this.nuevoCliente.nombre || !this.nuevoCliente.documento) {
        Swal.fire('Error', 'Nombre y documento son requeridos', 'error');
        return;
      }
      this.guardandoCliente = true;
      try {
        const res = await crearCliente(this.nuevoCliente);
        if (res.success) {
          const resC = await obtenerClientes();
          if (resC.success) this.todosLosClientes = resC.data;
          this.seleccionarCliente(res.data);
          this.modoCliente = 'buscar';
          Swal.fire('¡Éxito!', 'Cliente creado y seleccionado', 'success');
        } else {
          Swal.fire('Error', res.error || 'No se pudo crear el cliente', 'error');
        }
      } catch (e) {
        Swal.fire('Error', 'Error de conexión', 'error');
      } finally {
        this.guardandoCliente = false;
      }
    },

    abrirModalRegistro() {
      this.modoEdicion = false;
      this.clienteSeleccionado = null;
      this.modoCliente = 'buscar';
      this.paginaActual = 1;
      
      const currentUser = getCurrentUser();
      let defaultIdTecnico = null;
      if (currentUser) {
        const userId = currentUser.idUsuario || currentUser.id;
        const tecnicoAsociado = this.tecnicos.find(t => parseInt(t.idUsuario) === parseInt(userId));
        if (tecnicoAsociado) defaultIdTecnico = tecnicoAsociado.idTecnico;
      }
      
      this.form = {
        idInterServicio: null, idCliente: null, numeroAbonado: '', planContratado: '',
        tipoSolicitud: 'INSTALACION', estatus: 'PENDIENTE', serialONT: '', serialRouter: '',
        costoInstalacion: 0, montoPagado: 0, idTecnico: defaultIdTecnico, fechaInstalacion: null, observaciones: ''
      };
      this.modalAbierto = true;
    },
    editarServicio(item) {
      this.modoEdicion = true;
      this.form = { ...item };
      this.clienteSeleccionado = this.todosLosClientes.find(c => (c.idCliente || c.id) === item.idCliente);
      this.modalAbierto = true;
    },
    async guardarServicio() {
      if (!this.form.idCliente || !this.form.planContratado) {
        Swal.fire('Atención', 'Cliente y Plan son requeridos', 'warning');
        return;
      }
      try {
        const res = this.modoEdicion 
          ? await actualizarInterServicio(this.form.idInterServicio, this.form)
          : await crearInterServicio(this.form);
        if (res && res.success) {
          Swal.fire({ title: '¡Hecho!', text: res.message, icon: 'success', timer: 1500, showConfirmButton: false });
          this.cerrarModal();
          this.cargarDatos();
        } else {
          Swal.fire('Error', res?.error || 'Error procesando solicitud', 'error');
        }
      } catch (error) {
        Swal.fire('Error', 'Error crítico de servidor', 'error');
      }
    },
    async eliminarRegistro(id) {
      const confirm = await Swal.fire({
        title: '¿Eliminar registro?',
        text: "No se podrá deshacer esta acción.",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#e11d48',
        confirmButtonText: 'Sí, eliminar',
        cancelButtonText: 'Cancelar'
      });
      if (confirm.isConfirmed) {
        const res = await eliminarInterServicio(id);
        if (res && res.success) {
          Swal.fire('Eliminado', 'Registro borrado.', 'success');
          this.cargarDatos();
        }
      }
    },
    abrirModalPago(item) {
      this.itemPago = item;
      this.pagoForm = {
        metodo: 'EFECTIVO',
        referencia: '',
        monto: this.itemPago.costoInstalacion || 0,
        moneda: 'USD',
        tasaCambio: null,
        registrarEnCaja: true
      };
      this.showPaymentModal = true;
    },
    async finalizarConPago() {
      this.paying = true;
      try {
        let montoUSD = 0;
        let montoVES = 0;
        
        if (this.pagoForm.registrarEnCaja && this.pagoForm.monto > 0) {
          if (this.pagoForm.moneda === 'VES' && this.pagoForm.tasaCambio) {
            montoUSD = this.pagoForm.monto / this.pagoForm.tasaCambio;
            montoVES = this.pagoForm.monto;
          } else if (this.pagoForm.moneda === 'USD') {
            montoUSD = this.pagoForm.monto;
          }
        }
        
        const payload = {
          ...this.itemPago,
          estatus: 'INSTALADO',
          montoPagado: montoUSD > 0 ? (this.itemPago.montoPagado + montoUSD) : this.itemPago.montoPagado
        };
        
        const res = await actualizarInterServicio(this.itemPago.idInterServicio, payload);
        
        if (res.success) {
          if (this.pagoForm.registrarEnCaja) {
            const pagoCaja = {
              monto: montoUSD,
              metodo: this.pagoForm.metodo,
              referencia: this.pagoForm.referencia,
              monedaOriginal: this.pagoForm.moneda,
              montoOriginal: montoVES > 0 ? montoVES : null,
              tasaCambio: this.pagoForm.tasaCambio
            };
            
            await registrarPagoCaja(this.itemPago, pagoCaja);
            Swal.fire({ title: '¡Hecho!', text: `Instalado y abono de $${montoUSD.toFixed(2)} registrado en caja`, icon: 'success', timer: 2000, showConfirmButton: false });
          } else {
            Swal.fire({ title: '¡Hecho!', text: "Servicio finalizado e instalado", icon: 'success', timer: 1500, showConfirmButton: false });
          }
          
          this.showPaymentModal = false;
          await this.cargarDatos();
        } else {
          Swal.fire('Error', res.error || "Error al procesar", 'error');
        }
      } catch (error) {
        console.error("Error:", error);
        Swal.fire('Error', "Error al procesar", 'error');
      } finally { 
        this.paying = false; 
      }
    },
    cerrarModal() { this.modalAbierto = false; }
  },
  mounted() { this.cargarDatos(); }
};
</script>

<style scoped>
.text-lexend { font-family: 'Lexend', sans-serif; }
.custom-scrollbar::-webkit-scrollbar { width: 6px; height: 6px; }
.custom-scrollbar::-webkit-scrollbar-track { background: transparent; }
.custom-scrollbar::-webkit-scrollbar-thumb { background: #e2e8f0; border-radius: 10px; }
.dark .custom-scrollbar::-webkit-scrollbar-thumb { background: #334155; }

@keyframes zoomIn {
  from { opacity: 0; transform: scale(0.95); }
  to { opacity: 1; transform: scale(1); }
}
.animate-zoomIn { animation: zoomIn 0.2s ease-out; }

@keyframes fadeInUp {
  from { opacity: 0; transform: translateY(15px); }
  to { opacity: 1; transform: translateY(0); }
}
.animate-fadeInUp { animation: fadeInUp 0.4s ease-out forwards; }
.delay-100 { animation-delay: 0.1s; }

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}
.animate-fadeIn { animation: fadeIn 0.3s ease-out; }

.transition-all { transition: all 0.3s ease; }
html { scroll-behavior: smooth; }

@media (max-width: 640px) {
  button { min-height: 44px; min-width: 44px; }
}
</style>